<template>
  <div>
    <div class="d-flex align-items-center mb-4">
      <div class="mr-auto">
        <h1>
          {{ $t('myBountyCampaigns') }}
          <!-- <span
            class="text-primary ml-3"
            style="font-size: 60%; font-weight: normal;"
          >
            {{ campaignList && campaignList.length }} campaigns
          </span> -->
        </h1>
      </div>
    </div>
    <b-row class="mb-4">
      <b-col lg="2" md="4">
        <multi-select
          size="lg"
          class="rounded-0"
          :options="selectData.options"
          :select-options="statuses"
          v-model="form['filter[sn]']"
          :btn-label="$tc('status', 2)"
        />
      </b-col>
    </b-row>
    <list-bounty-campaign
      :list="campaignList"
      v-infinite-scroll="loadMore"
      infinite-scroll-disabled="busy"
      infinite-scroll-distance="10"
    >
      <div slot="campaign" slot-scope="{ campaign }">
        <bounty-campaign :campaign="campaign">
          <template slot="header-right-col">
            <router-link
              v-if="campaign.status === 'pending'"
              :to="{ name: 'campaign-edit', params: { id: campaign.id } }"
              class="btn-link-alt"
            >
              <svg-icon icon="pencil" />
              <span>{{ $t('editCampaign') }}</span>
            </router-link>
          </template>
          <template slot="details">
            <div></div>
          </template>
          <div
            slot="tasks"
            slot-scope="{ tasks, campaign: campaignSlot }"
            class="position-relative"
          >
            <div class="my-campaign__tasks">
              <task-manager
                :fields="fields"
                hover
                :has-access-for-create="true"
                :tasks="tasks"
                :campaign="campaignSlot"
                :campaign-list-id="campaign.id"
              >
                <template slot="task-name" slot-scope="{ task }">
                  <link-task
                    :campaign-id="campaignSlot.id"
                    :name="task.title"
                  />
                </template>
                <template slot="actions-td" slot-scope="{ task }">
                  <div>
                    <b-dropdown
                      toggle-class="p-0 border-0 my-campaign__actions"
                      right
                      variant="link"
                      size="lg"
                      no-caret
                    >
                      <template slot="button-content">
                        <svg-icon icon="dots" class="icon-lg align-top" />
                      </template>
                      <!-- <b-dropdown-item
                        @click="downloadCsvTask(task)"
                        class="small font-weight-bold"
                      >
                        {{ $t('csvStats') }}
                      </b-dropdown-item> -->
                      <b-dropdown-item
                        @click="editTask(campaignSlot.id, task)"
                        class="small font-weight-bold"
                      >
                        {{ $t('edit') }}
                      </b-dropdown-item>
                      <!-- <b-dropdown-item
                        @click="deleteTask(task)"
                        class="small font-weight-bold text-danger"
                      >
                        {{ $t('delete') }}
                      </b-dropdown-item> -->
                    </b-dropdown>
                  </div>
                </template>
              </task-manager>
            </div>
          </div>
        </bounty-campaign>
      </div>
    </list-bounty-campaign>
    <list-empty v-if="!hasMore && !isLoading" />
  </div>
</template>

<script>
import ListBountyCampaign from '@/components/BountyCampaign/ListBountyCampaign.vue';
import ListEmpty from '@/components/BountyCampaign/ListEmpty.vue';
import BountyCampaign from '@/components/BountyCampaign/BountyCampaign.vue';
import { loadingMixin, statusClassesMixin } from '@/utils/mixins.js';
import campaignsMixin from './mixins/campaigns.js';
import TaskManager from './components/CampaignAdd/TaskManager.vue';
import LinkTask from '@/components/LinkTask.vue';
import cloneDeep from 'clone';

export default {
  components: {
    ListBountyCampaign,
    ListEmpty,
    BountyCampaign,
    TaskManager,
    LinkTask
  },

  mixins: [loadingMixin, statusClassesMixin, campaignsMixin],

  data() {
    return {
      selectData: {
        options: {
          multi: true,
          labelName: 'name'
        }
      },
      statuses: [...this.$config.statuses.values()].map(el => {
        return {
          name: this.$filters.capitalize(this.$t(`statuses.${el}`)),
          value: el
        };
      }),
      form: {
        'filter[sn]': [],
        'filter[m][]': this.$store.state.app.user.id
      },
      fields: [
        {
          label: this.$filters.capitalize(this.$tc('task', 1)),
          key: 'title',
          class: 'txt-5-alt',
          tdClass: 'align-middle pt-0 pb-0 pl-2'
        },
        {
          label: this.$tc('status', 1),
          key: 'status',
          class: 'txt-5-alt',
          tdClass: 'align-middle pt-0 pb-0 text-center'
        },
        {
          label: this.$t('startDate'),
          key: 'startAt',
          class: 'txt-5-alt',
          tdClass: 'align-middle pt-0 pb-0 text-center',
          formatter: val => {
            return this.$date.format(val, 'DD.MM.YYYY');
          }
        },
        {
          label: this.$t('endDate'),
          key: 'endAt',
          class: 'txt-5-alt',
          tdClass: 'align-middle pt-0 pb-0 text-center',
          formatter: val => {
            return this.$date.format(val, 'DD.MM.YYYY');
          }
        },
        {
          label: this.$t('maxParticipants'),
          key: 'maxParticipants',
          class: 'txt-5-alt text-center',
          tdClass: 'align-middle pt-0 pb-0'
        },
        {
          label: this.$filters.capitalize(this.$tc('participant', 6)),
          key: 'participants',
          class: 'txt-5-alt text-center',
          tdClass: 'align-middle pt-0 pb-0'
        },
        {
          key: 'actions',
          class: 'txt-5-alt pr-0',
          label: '',
          tdClass: 'align-middle'
        }
      ]
    };
  },

  watch: {
    form: {
      deep: true,
      handler() {
        const form = cloneDeep(this.form);
        form['filter[sn]'] = form['filter[sn]'].map(el =>
          el.value.toLowerCase()
        );
        this.updateFilters(form);
      }
    }
  },

  methods: {
    editTask(campaignId, task) {
      this.$router.push(
        `/campaigns/${campaignId}/task-edit/${task.title.toLowerCase()}`
      );
    },
    deleteTask() {
      alert('Закройте глаза и представьте что кампания удалилась');
    }
  }
};
</script>

<style lang="scss">
.my-campaign {
  &__tasks {
    table {
      th {
        padding: 1rem 1.5rem;
        border-top: none;
        line-height: 1.4;
        vertical-align: middle;
      }
    }
  }

  &__actions {
    color: $lighten;

    &:hover {
      color: $primary;
    }
  }
}

.filter {
  flex-grow: 1;
  margin: -1px;
}
</style>
